import React, {useState}      from "react";
import { useDispatch }        from 'react-redux';
import classNames             from "classnames";

import Dropdown               from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon }    from '@fortawesome/react-fontawesome';
import { faCaretDown }        from '@fortawesome/free-solid-svg-icons';

import { w_header_options }   from "../../../data/SelectOptions";

import {
  changeBomParameter,
} from "../../../bomSlice";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </a>
));

const WHeader = (props) => {
  const dispatch = useDispatch()

  const {
    bom_parameters,
  } = props;

  const popperConfig = {
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 10],
        },
      }
    ]
  };

  return (
    <thead>
      <tr>
        <th className="identify-col"></th>
        {bom_parameters.map((col, index) => {
          const id = `identify-col-${index}`
          const selected_option = w_header_options.find((option) => option.value == col);
          const [dropdownTitle, setDropdownTitle] = useState(selected_option.text);

          const onSelect = (option) => {
            setDropdownTitle(option.text.replace(" (Optional) ", ""));
            dispatch(changeBomParameter({ index, value: option.value }))
          }
          
          return (
            <th key={id} id={id} data-column={index}
              className={classNames("identify-col", {"selected": selected_option.value !== ""})}>
              <Dropdown>
                <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                  <div className="sel">
                    <span>{dropdownTitle}</span>
                    <i className="ps-1"><FontAwesomeIcon icon={faCaretDown}/></i>
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu renderOnMount={true} popperConfig={popperConfig}>
                  {w_header_options.map((option, o_index) => (
                    <Dropdown.Item key={`option_${o_index}`} eventKey={option.text} 
                      onClick={() => onSelect(option)}>
                        {option.text}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </th>
          )
        })}
      </tr>
    </thead>
  )
} 

export default WHeader;